import React,{useState} from 'react'
import grad from './Images/grad.svg'
import './AddUniversity.css'

import firebase from './Firebase';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
  import { useStateValue } from './StateProvider'
import { storage,db,auth,serverTimestamp } from './Firebase';

function AddUniversity() {
    const [{ user },dispatch]= useStateValue();
    const   success = () => toast.success('📤 Request Sent', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
      
const [uniname,setUniname]= useState('')
const [address,setAddress]=useState('')
const [image,setImage]=useState(null)
const [url,setUrl]=useState('')
const handleChange=e=>{
    if(e.target.files[0]){
      setImage(e.target.files[0])
      
    }
    
    
  }
  const sendRequest =(e)=>{
      e.preventDefault()
   
    const uploadTask= storage.ref(`universityImages/${image.name}`).put(image)
    uploadTask.on("state_changed",
      snapshot =>{},
      error =>{
        console.log("e>",error)
      },
      ()=>{
        storage.ref("universityImages").child(image.name).getDownloadURL().then(url=>{
          setUrl(url)
          
          auth.onAuthStateChanged((authUser)=>{
 
           db.collection("Universities").doc(uniname).set({
            Name: uniname,
            Address: address,
            url:url,
            RequestStatus:"pending",
            RequestedBy: user?.email,
            DateRequested:firebase.firestore.FieldValue.serverTimestamp(),
            
           })
           console.log("auth ",authUser)
         })
         setImage(null)
        success()
         setAddress('')
         setUniname('')
        })
      }
    )
     
    
  }
  return (
    <div className='adduni_main'>
        <div className="au1">
            <form action="">
                <div className="au_form">
                    <div className="au_formelement">
                        <p>University Name</p>
                        <input type="text" name="" id="" value={uniname} onChange={e=>setUniname(e.target.value)}/>

                    </div>
                    <div className="au_formelement">
                        <p>University Address</p>
                        <input type="text" name="" id="" value={address} onChange={e=>setAddress(e.target.value)} />
                        
                    </div>
                    <div className="au_formelement">
                        <p>Image</p>
                        <input type="file" accept="image/png, image/jpeg" name="" id="" onChange={handleChange} />
                        
                    </div>
                    <div className="au_btn">
                        <button onClick={sendRequest}>Send Request</button>
                    </div>
                </div>
            </form>
        </div>
        <div className="au2">
            <img src={grad} alt="" />
        </div>
        <ToastContainer
position="top-right"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
/>
    </div>
  )
}

export default AddUniversity